import {
  ITEM_AVAILABILITY_STATUS,
  ITEM_AVAILABILITY_STATUS_OPTIONS,
  STATUS_TO_BOOLEANS,
} from 'features/Sku/Items/SkuItems.constants';

// A group carries no sold_out, so it has no "unavailable today"; unavailability is indefinite only.
export const GROUP_AVAILABILITY_OPTIONS = [
  ITEM_AVAILABILITY_STATUS.AVAILABLE,
  ITEM_AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITELY,
];

// A modifier created sold out could carry no return time, since the create endpoints lack flip_back_at.
export const UNSAVED_OPTION_AVAILABILITY_OPTIONS = ITEM_AVAILABILITY_STATUS_OPTIONS.filter(
  status => status !== ITEM_AVAILABILITY_STATUS.UNAVAILABLE_TODAY
);

// Not getItemAvailabilityStatus: that returns null unless the entity is published, and resolves
// "indefinitely" from partnerState, which the modifier contract never sends.
export const getModifierAvailabilityStatus = modifier => {
  if (modifier?.enabled === false) return ITEM_AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITELY;
  if (modifier?.soldOut === true) return ITEM_AVAILABILITY_STATUS.UNAVAILABLE_TODAY;
  return ITEM_AVAILABILITY_STATUS.AVAILABLE;
};

export const toModifierAvailability = status => {
  const { enabled, soldOut } = STATUS_TO_BOOLEANS[status] || STATUS_TO_BOOLEANS[ITEM_AVAILABILITY_STATUS.AVAILABLE];
  return { enabled, soldOut };
};
